const MENU = {
  PARAMETERS: 'parameters',
  ORGANIZATIONS: 'organizations',
  SITE: 'site',
  HOME: 'home'
}

/**
 * Top-level side menu section identifiers.
 */
export { MENU }
